<template>
  <v-row justify="center">
    <v-col cols="12" class="pt-16">
      <v-container>
        <back-button @click.native="$router.go(-1)"></back-button>
        <v-row>
          <v-col cols="12" lg="6">
            <h3 class="mb-8 home-header-3">
              Which of the following apply to you?
            </h3>
            <div
              v-for="demographicsItem in demographicsItems"
              :key="demographicsItem.value"
            >
              <v-checkbox
                v-model="demographics"
                v-on:change="onCheckboxGroupClicked"
                v-on:keyup.native.enter="
                  addRemoveDemographics(demographicsItem.value)
                "
                :label="demographicsItem.label"
                :value="demographicsItem.value"
                color="#006078"
                class="ml-4 black--text"
                :ripple="false"
              ></v-checkbox>
            </div>
            <v-btn @click="onAfterContinueClicked" class="mt-8 v-btn--primary">
              Continue
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import BackButton from '@/components/BackButton';
import demographicsItems from '@/data/demographics';
import moment from 'moment/moment';

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepBookingTypes',
  data: () => ({
    demographicsItems: demographicsItems,
    demographics: []
  }),
  mounted: function() {
    this.$store.commit('setDemographics', []);
    this.$store.commit('setFrontlineHealthAndSocialCareWorker', null);
  },
  computed: {
    ...mapGetters([
      'getHealthAndSocialCareWorker',
      'getFrontlineHealthAndSocialCareWorker',
      'getAge',
      'getAgeInMonths',
      'getDemographics',
      'getDateOfBirth',
      'isInfluenzaFlowDisabled',
      'isCovidFlowDisabled',
      'isCovidEligible'
    ]),
    ifWillTurn75BeforeApril2026() {
      const referenceDate = moment('2026-03-31', 'YYYY-MM-DD') // 31 March 2026
      const ageOnReferenceDate = referenceDate.diff(this.getDateOfBirth, 'years') // Calculate age on 31 March 2026
      return ageOnReferenceDate >= 75
    },
    ifWillTurn65BeforeApril2026() {
      const referenceDate = moment('2026-03-31', 'YYYY-MM-DD') // 31 March 2026
      const ageOnReferenceDate = referenceDate.diff(this.getDateOfBirth, 'years') // Calculate age on 31 March 2026
      return ageOnReferenceDate >= 65
    },
    ifWillTurn65BeforeApril2027() {
      const referenceDate = moment('2027-03-31', 'YYYY-MM-DD') // 31 March 2027
      const ageOnReferenceDate = referenceDate.diff(this.getDateOfBirth, 'years') // Calculate age on 31 March 2027
      return ageOnReferenceDate >= 65
    }
  },
  methods: {
    addRemoveDemographics(value) {
      const index = this.demographics.indexOf(value);
      if (index > -1) {
        this.demographics.splice(index, 1);
      } else {
        this.demographics.push(value);
      }
    },
    saveDemographics() {
      this.$store.commit('setDemographics', this.demographics);
    },
    onCheckboxGroupClicked() {
      this.saveDemographics();
    },
    isEligibleForCovidVaccine() {
      if (!this.isCovidEligible) {
        return false;
      }

      return !this.isCovidFlowDisabled && (
        this.ifWillTurn75BeforeApril2026 ||
        this.getDemographics.includes('Care Home Resident') ||
        this.getDemographics.includes('Immunosuppressed') && this.getAge >= 12
      )
    },
    isEligibleForCovidUnder12Vaccine() {
      if (!this.isCovidEligible) {
        return false;
      }

      return !this.isCovidFlowDisabled && (
        this.getAgeInMonths >= 6 &&
        this.getAge < 12 &&
        this.getDemographics.includes('Immunosuppressed')
      )
    },
    isEligibleForInfluenzaVaccine() {
      return !this.isInfluenzaFlowDisabled && (
        this.ifWillTurn65BeforeApril2027 ||
        this.getFrontlineHealthAndSocialCareWorker ||
        this.getDemographics.includes('HSC Worker') ||
        this.getDemographics.includes('Care Home Resident') ||
        this.getDemographics.includes('Pregnant') ||
        (this.getAge >= 18 && (
          (
            this.getDemographics.includes('At Risk') &&
            this.getAge < 65
          ) ||
          this.getDemographics.includes('Close Contact') ||
          this.getDemographics.includes('Bird Culler/cattle & swine workers') ||
          this.getDemographics.includes('Carer') ||
          this.getDemographics.includes('HSC Worker') ||
          this.getDemographics.includes('Immunosuppressed') ||
          this.getDemographics.includes('Rough sleepers and homeless')
        ))
      )
    },
    onAfterContinueClicked() {
      this.$gtag.event('Demographics filled', {})

      this.$store.commit('setIsEligibleForCovidVaccine', this.isEligibleForCovidVaccine())
      this.$store.commit('setIsEligibleForCovidUnder12Vaccine', this.isEligibleForCovidUnder12Vaccine())
      this.$store.commit('setIsEligibleForInfluenzaVaccine', this.isEligibleForInfluenzaVaccine())

      if(this.isEligibleForCovidVaccine() || this.isEligibleForCovidUnder12Vaccine()) {
        if (this.getDemographics.includes('HSC Worker')) {
          this.$router.push('/booking/trust').catch(() => {});
        } else {
          this.$router.push('/booking/booking-disclaimer').catch(() => {});
        }
      } else if (this.isEligibleForInfluenzaVaccine()) {
        if (this.getDemographics.includes('HSC Worker')) {
          this.$router.push('/booking/trust').catch(() => {});
        } else {
          this.$router.push('/booking/booking-types-2').catch(() => {});
        }
      } else {
        this.$router.push('/booking/covid-flu-letter').catch(() => {});
        // this.$router.push('/booking/flu-letter').catch(() => {});
      }
    }
  }
});
</script>
